import React, { useEffect, useState } from "react";
import classes from "./Crm.module.css";
import { NOTE_CRM } from "../../../utils/constants/assets";
import ContactDetailEmptyScreen from "./components/AccountDetailEmptyScreen";
import { STRINGS } from "../strings";
import CreateNoteCrmPopUp from "./components/CreateNoteCrmPopUp";
import TypographyInline from "../../../components/Typography/TypographyInline";
import { BRAND } from "../../../utils/constants/colors";
import { fontWeight } from "../../../utils/constants/UI";
import { Button } from "../../../components/Buttons";
import ListingNoteCard from "./components/ListingNoteCard";
import SkeletonLoaderCRMScreens from "./components/SkeletonLoaderCRMScreens";
import { decompressString } from "../../../utils/helpers";

const AccountDetailNoteScreen = ({
  contactDetails,
  contactId,
  noteListData = [],
  setNoteListData = () => {},
  screenLoading = false,
  totalNotes = 0,
  getNoteLogList = () => {},
}) => {
  const [createFlag, setCreateFlag] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  const emptyScreenButtons = [
    {
      id: STRINGS.NOTE,
      label: STRINGS.CREATE_NOTE,
      variant: "primary",
      disabled: !Object.keys(contactDetails).length,
      onClick: () => {
        setCreateFlag(true);
      },
    },
  ];

  //Click for open the createNote PopUp

  const createTaskOpenHandler = () => {
    setCreateFlag(true);
  };

  const onScrollApiHandler = () => {
    const scrollableDiv = document?.getElementsByClassName(
      STRINGS.ALL_NOTE_LIST
    )[0];
    const isAtBottom =
      scrollableDiv?.scrollTop >=
      scrollableDiv?.scrollHeight - scrollableDiv?.clientHeight;
    if (isAtBottom && totalNotes > noteListData?.length) {
      setPageCount(pageCount + 1);
      getNoteLogList(true, pageCount + 1);
    }
  };

  useEffect(() => {
    if (contactDetails) {
      getNoteLogList();
    }
  }, [contactDetails]);

  return (
    <div
      className={`${classes.noteContainer} ${STRINGS.ALL_NOTE_LIST}`}
      id="comments_body"
      onScroll={onScrollApiHandler}
    >
      {screenLoading ? (
        <SkeletonLoaderCRMScreens
          loaderHeight="42px"
          accordionLengths={10}
          buttonsLength={1}
        />
      ) : (
        <>
          {" "}
          {/* Checking the length of the Note list */}
          {noteListData?.length ? (
            <div className={classes.taskListContainer}>
              <div className={classes.HeadTaskContainerSubHead}>
                <TypographyInline
                  label={STRINGS.ALL_NOTES}
                  size={"md"}
                  fontWeight={fontWeight.SEMIBOLD}
                  color={BRAND.SECONDARY}
                />
                <div className={classes.WIdthButton}>
                  <Button
                    label={STRINGS.CREATE_NOTE}
                    variant={"primary"}
                    size={"sm36"}
                    onClick={createTaskOpenHandler}
                  />
                </div>
              </div>
              {/* Sending Task list to the ListingTaskCard*/}
              {noteListData?.map((logData, index) => {
                return (
                  <div key={`log${index}`}>
                    <ListingNoteCard
                      contactId={contactId}
                      id={`log${index}`}
                      logData={
                        logData?.is_compressed
                          ? {
                              ...logData,
                              notes_body: decodeURIComponent(
                                decompressString(logData.notes_body)
                              ),
                            }
                          : logData
                      }
                      noteListData={noteListData}
                      setNoteListData={setNoteListData}
                      expanded={!index}
                      contactDetails={contactDetails}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className={classes.TaskHead}>
              <ContactDetailEmptyScreen
                src={NOTE_CRM}
                label={STRINGS.NOTE_DESC}
                buttonItems={emptyScreenButtons}
              />
            </div>
          )}
        </>
      )}

      {createFlag && (
        <CreateNoteCrmPopUp
          open={createFlag}
          close={setCreateFlag}
          setNoteListData={setNoteListData}
          contact_id={contactId}
          getNotes={getNoteLogList}
        />
      )}
    </div>
  );
};

export default AccountDetailNoteScreen;
